import { AppUppyFile } from 'common';

export interface ProgressBarDialogComponentConfig {
  filesToUpload: AppUppyFile[];
  generateEndpoint?: (meta: any) => string;
}

export enum ProgressBarDialogComponentResultEnum {
  Completed = 'completed',
  Canceled = 'canceled'
}
